/**
 * "Hoje" que troca sozinho à meia-noite local.
 *
 * Atraso é CALCULADO contra hoje, nunca gravado. Antes, hoje só era
 * recalculado quando a planilha recarregava: um tablet aberto a noite toda
 * amanhecia com o atraso de ontem, e o ambiente que venceu à meia-noite não
 * ficava vermelho até alguém mexer na planilha.
 */
import { useEffect, useState } from "react";

// Folga depois da meia-noite: o timer não pode disparar em 23:59:59,999.
const FOLGA_MS = 1000;

export function msAteAMeiaNoite(agora = new Date()) {
  const amanha = new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() + 1);
  return amanha.getTime() - agora.getTime() + FOLGA_MS;
}

export default function useHoje() {
  const [hoje, setHoje] = useState(() => new Date());
  useEffect(() => {
    const timer = setTimeout(() => setHoje(new Date()), msAteAMeiaNoite(hoje));
    return () => clearTimeout(timer);
  }, [hoje]);
  return hoje;
}
